import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { canOpenPath } from './AdminLayout';

const ProtectedRoute = ({ children }) => {
  const { user, loading, sessionEnded } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950 text-slate-300" data-testid="auth-loading">
        <div className="animate-pulse">Authenticating…</div>
      </div>
    );
  }

  if (!user) {
    // Remember the target only for a cold deep-link, never after a sign-out.
    return <Navigate to="/admin/login" state={sessionEnded ? null : { from: location }} replace />;
  }

  // Staff logins get their own self-service screens plus any back-office
  // module the master admin has explicitly granted them — the permission
  // toggles on the Admin Users page are the single source of truth, for staff
  // and managers alike. Their own portal (/staff) is always reachable.
  if (user.role === 'staff' && location.pathname.startsWith('/admin')
      && !canOpenPath(location.pathname, user)) {
    const home = (user.permissions || {}).can_self_mark_attendance
      ? '/admin/my-attendance'
      : '/staff';
    return <Navigate to={home} replace state={{ denied: location.pathname }} />;
  }

  return children;
};

export default ProtectedRoute;
